<template>
<div>
  <b-card no-body class="mb-1 mt-1">
    <b-card-header header-tag="header" class="p-0 ">
        <b-btn block href="#" v-b-toggle.examples variant="info" class="text-left">Documentation</b-btn>
    </b-card-header>
      <b-collapse id="examples" visible>
        <b-card-body>
          <b-row>
            <b-col cols="3">
              <table class="table table-sm color mb-2">
                <caption class="caption table-caption">Examples</caption>
                <tbody>
                    <tr>
                      <td class="text-left">
                        <b-btn size="sm" variant="link" @click="getExampleUrl('CppClientExample')">Cpp Example</b-btn>
                      </td>
                    </tr>
                  <tr>
                    <td class="text-left">
                      <b-btn size="sm" variant="link" @click="getExampleUrl('ExcelClientExample')">Excel Example</b-btn>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-left">
                      <b-btn size="sm" variant="link" @click="getExampleUrl('CsClientExample')">C# Example</b-btn>
                    </td>
                  </tr>
                </tbody>
              </table>
            </b-col>
            <b-col cols="3">
              <table class="table table-sm color mb-2">
                <caption class="caption table-caption">Docs</caption>
                <tbody>
                  <tr>
                    <td class="text-left">
                      <b-btn size="sm" variant="link" href="https://documenter.getpostman.com/view/10166931/SzKWuHJn?version=latest" target="_blank">
                        Web Api - Exposed Functions
                      </b-btn>
                    </td>
                  </tr>
                  <tr v-if="this.$store.getters.isLDMUser">
                    <td class="text-left">
                      <b-btn size="sm" variant="link" href="https://documenter.getpostman.com/view/10166931/SzYdUcp8?version=latest" target="_blank">
                        LDM Exposed Functions
                      </b-btn>
                    </td>
                  </tr>
                  <tr v-if="this.$store.getters.isAFTUser">
                    <td class="text-left">
                      <b-btn size="sm" variant="link" href="https://documenter.getpostman.com/view/10166931/SzYevFC7?version=latest" target="_blank">
                        AFT Exposed Functions
                      </b-btn>
                    </td>
                  </tr>
                </tbody>
              </table>
            </b-col>
          </b-row>
        </b-card-body>
      </b-collapse>
    </b-card>
    </div>
</template>

<script>
import Login from "@/components/Login.vue"
import service from "../services/HttpRequestService";

export default {
  data() {
    return {
      isLogged: false
    }
  },

  methods: {
    getExampleUrl(fileName) {
      this.getUrl("documentation/examples/" + fileName);
    },
    getDocUrl(fileName) {
      this.getUrl("documentation/docs/" + fileName);
    },
    getUrl(url) {
      let newWindow = window.open();
      service.get(url).then(res => {
        newWindow.location = res.data;
      });
    }
  },

  components: {
    Login
  }
}
</script>

<style lang="scss">
</style>